module.exports = __webpack_public_path__ + "images/emoji/full_moon.14ce2bd593d05bf1c754.png";